import Vue from "vue";
import email from "./Email.vue";

export function load() {
    const selector = "email-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
        createElement(email, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
